export default __webpack_public_path__ + "057311b13bf4963961ffc4a369a1810d.svg";